import { Box, Button, Tooltip, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { ElementSearchBox } from "../../ElementSearchBox";
import { assertThumbnailUrl, LoadState } from "../../../../redux/common";
import { useAppDispatch } from "../../../../app/hooks";
import { executeUsersQuery, usersQuerySlice, selectUsersQuery } from "../../../../redux/user/usersQuerySlice";
import { UserInfo } from "../../../../redux/user/userSlice";
import FragmentFullContent from "../../FragmentFullContent";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PrizaAvatarGrid, { PrizaAvatarGridItem } from "../../grid/PrizaAvatarGrid";
import { useEffect } from "react";

interface PossibleUsersListProps {
    inviteUser: () => void;
    addUser: (user: UserInfo) => void;
    hasUser: (user: UserInfo) => boolean;
}

let searchCount = 0;

const PossibleUsersList = (props: PossibleUsersListProps) => {
    const dispatch = useAppDispatch();
    const usersQuery = useSelector(selectUsersQuery);

    useEffect(() => {
        if (usersQuery.state.state == LoadState.NotStarted) {
            dispatch(executeUsersQuery({ filter: usersQuery.filter }));
        }
    }, [usersQuery.state.state]);

    const inviteUser = () => {
        props.inviteUser();
    };

    const list = usersQuery.list || [] as UserInfo[];
    const mapped = list
        .filter((item: UserInfo) => {
            return !props.hasUser(item);
        })
        .map((item: UserInfo) => {
            return {
                image: assertThumbnailUrl(item.url),
                title: item.name || item.email,
                subtitle: item.email,
                avatar: item.url,
                click: () => {
                    props.addUser(item);
                },
                extra: <Tooltip title="Conceder permissão de acesso a este usuário">
                    <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                        <Button variant="outlined" size="small" color='success' onClick={() => {
                            props.addUser(item);
                        }}>
                            <PersonAddIcon />
                        </Button>
                    </Box>
                </Tooltip>,
                } as PrizaAvatarGridItem;
        });

    const doQuery = (/* reason: string */) => {
        dispatch(executeUsersQuery({ filter: usersQuery.filter }));
    };

    return <PrizaAvatarGrid
        list={mapped}
        size='60px'
        toolbar={{
            label: <Box sx={{ width: { xs: "75%", sm: "100%", height: "100px" } }}>
                <Typography variant="h6" component="div" sx={{ m: 1 }}>
                    Usuários disponíveis
                </Typography>
                <ElementSearchBox
                    filter={usersQuery.filter}
                    setFilter={(filter: string) => {
                        console.log(`setFilter(${filter})`);
                        dispatch(usersQuerySlice.actions.setFilter(filter));
                        searchCount++;
                        setTimeout(() => {
                            searchCount--;
                            console.debug(`Search '${filter}'? ${searchCount} = 0 :: ${searchCount == 0}`);
                            if (searchCount == 0) {
                                doQuery(/* "timeout" */);
                            }
                        }, 1000);
                    }}
                    placeholder="Procurar usuários"
                    label="search"
                    search={(e: any) => {
                        e.preventDefault();
                        searchCount = 0;
                        doQuery(/* "requested" */);
                    }}
                    working={usersQuery.state.state == LoadState.Loading}
                />
            </Box>,
            position: "top",
            buttons: [
                {
                    label: <Tooltip title="Convidar novo usuário">
                        <PersonAddIcon />
                    </Tooltip>,
                    click: () => {
                        inviteUser();
                    }
                }
            ],
        }}
        state={usersQuery.state}
        retry={() => {
            doQuery(/* "retry" */);
        }}
        messages={{
            empty: "Nenhum usuário encontrado com este filtro",
            error: "Erro ao carregar usuários."
        }}
        notStarted={
            <FragmentFullContent>
                Informe um filtro para carregar os usuários
            </FragmentFullContent>
        }
    />;

};

export default PossibleUsersList;